var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "popover-form-wrapper",
    {
      attrs: {
        note: _vm.note,
        "store-url": _vm.storeUrl,
        "can-set-read-only-note": _vm.canSetReadOnlyNote,
      },
      on: { stored: _vm.onStored },
    },
    [
      _c(
        "div",
        { staticClass: "wrapper" },
        [
          _vm._l(_vm.readOnlyNotes, function (item) {
            return _c(
              "div",
              { staticClass: "wrapper" },
              [
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "Special note visible to all users",
                      placement: "top",
                      effect: "light",
                    },
                  },
                  [_c("i", { staticClass: "fas fa-info-circle" })]
                ),
                _vm._v("\n      " + _vm._s(item.model.note) + "\n    "),
              ],
              1
            )
          }),
          _vm._v(" "),
          _c("multi-line-view", {
            attrs: { value: _vm.content, maxHeight: 75 },
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }